import React from "react";

function Member() {
  return (
    <div>
      <section id="member-details" className="member-details-main-block">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="member mb_60">
                <div className="row">
                  <div className="col-lg-6">

                    <h4>Duyuru</h4>
                    <br></br>
                    <p className="mb_30">
                      Şirketimizin 10.07.2024 tarihinde yapılan olağan genel kurul toplantısında
                      alınan 3-4-5-6-7 ve 8 numaralı kararlarına karşı <br></br>
                      Bakırköy 8. Asliye Ticaret Mahkemesinde 2024/791 Esas numarası ile iptal davası açılmıştır. <br></br>
                      Ön inceleme duruşması 27/11/2024 tarihinde saat 10.55'te yapılacaktır. Saygılarımızla duyururuz
                    </p>

                    <br></br>
                    <br></br>

                    <h3 className="bio-heading">Ticaret Sicil Gazeteleri</h3>

                    <br></br>
                    <br></br>

                    <h6>Ticaret Sicil Gazetesi, 17 Temmuz 2026, 11624 Sayılı İlanı</h6>
                    <a
                      href={require("../../assets/images/team_details/TemmuzAyi2026.pdf")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <h7>Görüntüle</h7>
                    </a>
                    <br></br>
                    <br></br>

                    <h6>Ticaret Sicil Gazetesi, 17 Haziran 2026, 11603 Sayılı İlanı</h6>
                    <a
                      href={require("../../assets/images/team_details/HaziranAyi2026.pdf")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <h7>Görüntüle</h7>
                    </a>
                    <br></br>
                    <br></br>

                    <h6>Ticaret Sicil Gazetesi, 25 Eylül 2024, 11172 Sayılı İlanı</h6>
                    <div>
                      <a
                        href={require("../../assets/images/team_details/EylulAyi.pdf")}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <h7>Görüntüle</h7>
                      </a>
                      <br></br>
                      <br></br>

                      <h6>Ticaret Sicil Gazetesi, 20 Haziran 2024, 11105 Sayılı İlanı</h6>
                      <a
                        href={require("../../assets/images/team_details/HaziranAyi.pdf")}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <h7>Görüntüle</h7>
                      </a>
                      <br></br>
                      <br></br>

                      <h6>Ticaret Sicil Gazetesi, 24 Mayıs 2024, 11089 Sayılı İlanı</h6>
                      <a
                        href={require("../../assets/images/team_details/MayisAyi.pdf")}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <h7>Görüntüle</h7>
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Member;
